export default {"src":"/_next/static/media/airdrop-external-link-illustration.7072bd6c.svg","height":211,"width":214};